/*
 * GENERATED - do not edit by hand.
 * Source: @kern-ux/native@2.7.2 (dist/kern.css)
 * Regenerate with: node scripts/generate-kern-tokens.mjs
 */

export const KERN_VERSION = '2.7.2';

export type KernColors = {
  backgroundDefault: string;
  backgroundHued: string;
  backgroundSurface: string;
  backgroundLevel1: string;
  backgroundLevel1Surface: string;
  backgroundLevel2: string;
  backgroundInverted: string;
  border: string;
  borderLevel1: string;
  borderLevel2: string;
  textDefault: string;
  textMuted: string;
  textInverse: string;
  actionDefault: string;
  actionOnDefault: string;
  actionVisited: string;
  actionFocus: string;
  formInputBackground: string;
  formInputBorder: string;
  feedbackDefault: string;
  feedbackDefaultBackground: string;
  feedbackDanger: string;
  feedbackDangerBackground: string;
  feedbackInfo: string;
  feedbackInfoBackground: string;
  feedbackSuccess: string;
  feedbackSuccessBackground: string;
  feedbackWarning: string;
  feedbackWarningBackground: string;
  decorativeBrand: string;
};

export const kernColors: { light: KernColors; dark: KernColors } = {
  light: {
    backgroundDefault: '#ffffff',
    backgroundHued: '#f3f4f7',
    backgroundSurface: '#f3f4f7',
    backgroundLevel1: '#f3f4f7',
    backgroundLevel1Surface: '#ffffff',
    backgroundLevel2: '#ffffff',
    backgroundInverted: '#000000',
    border: '#6e7597',
    borderLevel1: '#5b6185',
    borderLevel2: '#6e7597',
    textDefault: '#131525',
    textMuted: '#51577a',
    textInverse: '#f3f4f7',
    actionDefault: '#2044aa',
    actionOnDefault: '#ffffff',
    actionVisited: '#7e01a8',
    actionFocus: '#454b6b',
    formInputBackground: '#f3f4f7',
    formInputBorder: '#1d2034',
    feedbackDefault: '#454b6b',
    feedbackDefaultBackground: '#dfe1ea',
    feedbackDanger: '#c31c13',
    feedbackDangerBackground: '#fee4e0',
    feedbackInfo: '#006b8c',
    feedbackInfoBackground: '#c0f3ff',
    feedbackSuccess: '#007155',
    feedbackSuccessBackground: '#cdf2e4',
    feedbackWarning: '#925400',
    feedbackWarningBackground: '#ffe7b6',
    decorativeBrand: '#454b6b',
  },
  dark: {
    backgroundDefault: '#000000',
    backgroundHued: '#131525',
    backgroundSurface: '#131525',
    backgroundLevel1: '#131525',
    backgroundLevel1Surface: '#1d2034',
    backgroundLevel2: '#1d2034',
    backgroundInverted: '#ffffff',
    border: '#6e7597',
    borderLevel1: '#8187a7',
    borderLevel2: '#8e93b1',
    textDefault: '#f3f4f7',
    textMuted: '#b2b6cc',
    textInverse: '#131525',
    actionDefault: '#97afe1',
    actionOnDefault: '#000000',
    actionVisited: '#ce9ce8',
    actionFocus: '#a9aec6',
    formInputBackground: '#1d2034',
    formInputBorder: '#e8e9ef',
    feedbackDefault: '#e8e9ef',
    feedbackDefaultBackground: '#454b6b',
    feedbackDanger: '#ea7060',
    feedbackDangerBackground: '#4c0000',
    feedbackInfo: '#00a1cd',
    feedbackInfoBackground: '#002533',
    feedbackSuccess: '#16a884',
    feedbackSuccessBackground: '#00271b',
    feedbackWarning: '#d58100',
    feedbackWarningBackground: '#351b00',
    decorativeBrand: '#a9aec6',
  },
};

export const kernTypography = {
  fontFamily: '"Fira Sans", sans-serif',
  fontFamilyMono: '"Fira Mono", monospace',
  borderRadius: '0.25rem',
};
